export default "__VITE_ASSET__CcfWTRt3__"